import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../@core/service/api.service';

@Component({
  selector: 'ngx-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss'],
})
export class TasksComponent implements OnInit {
  tasks;

  search: string;

  constructor(private api: ApiService) { }

  ngOnInit() {
    this.api.taskList().subscribe(tasks => {
      this.tasks = tasks;
    })
  }

  async complete(task: any) {
    task.completed = !task.completed;
    await this.api.updateTask(task.completed, task);
  }

  filter(search: string, tasks: any[]) {
    if (search == null || search.length === 0) return tasks;
    const s = search.toLowerCase();
    return tasks.filter( x =>
      (x.project || '').toLowerCase().includes(s) ||
      (x.topic || '').toLowerCase().includes(s) ||
      (x.business || '').toLowerCase().includes(s) ||
      (x.responsible || '').toLowerCase().includes(s) ||
      (x.todo || '').toLowerCase().includes(s));
  }
}
